import React from "react";

const ErrorMessage = ({
  message = "Something went wrong.",
  title = "Error",
  onRetry,
  className = ""
}) => {
  return (
    <div className={`ui-error ${className}`} role="alert">
      <div className="ui-error-icon">
        !
      </div>

      <div className="ui-error-content">
        <h3>{title}</h3>

        <p>{message}</p>

        {onRetry && (
          <button
            type="button"
            className="ui-error-retry"
            onClick={onRetry}
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;